import Vue from "vue";

Vue.filter('dateformat',(value)=>{
    if(!value) return '';

    if(typeof value === 'string'){
        return value.substring(0,10);
    }
    return '';
});


// WEBPACK FOOTER //
// ./src/plugins/filters.js